var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRdnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedRdnt0)",
    d: "M11.036 9.591L6.215 6.214l3.377 4.822L4.286 12l5.306.964l-3.377 4.342l4.821-2.898l.964 5.306l.965-5.305l5.061 2.897l-4.097-4.342L19.715 12l-5.786-.964l3.857-4.822l-4.821 3.377L12 4.286z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedRdnt0",
    x1: 12,
    x2: 12,
    y1: 4.286,
    y2: 19.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A10F5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdnt);
export default __webpack_public_path__ + "static/media/rdnt.0e055ee6144772025da9a4ccdd1ed4cc.svg";
export { ForwardRef as ReactComponent };